import { createRoot } from 'react-dom/client';
import App from './app';
import './index.css';
import React from 'react';
import { NextStepProvider } from 'nextstepjs';

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <div className="font-sans antialiased">
      <NextStepProvider>
        <App />
      </NextStepProvider>
    </div>
  </React.StrictMode>
);
